<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules">
      <el-row :gutter="20">
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 24 }"
          :md="{ span: 24 }"
          :lg="{ span: 24 }"
        >
          <el-form-item
            :label="$l('form_label_groupName') || '评分组名称'"
            prop="appraisalGroupName"
          >
            <el-input
              v-model="formData.appraisalGroupName"
              maxlength="50"
              :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
              :disabled="isViewDisabled"
              clearable
              size="medium"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 24 }"
          :md="{ span: 24 }"
          :lg="{ span: 24 }"
        >
          <el-form-item
            :label="$l('form_label_groupNameEn') || '评分组名称英文'"
            prop="appraisalGroupNameEn"
          >
            <el-input
              v-model="formData.appraisalGroupNameEn"
              maxlength="50"
              :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
              :disabled="isViewDisabled"
              clearable
              size="medium"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 24 }"
          :md="{ span: 24 }"
          :lg="{ span: 24 }"
        >
          <el-form-item
            :label="$l('form_label_scoring_items') || '评分组说明'"
          >
            <el-input
              v-model="formData.appraisalGroupDesc"
              type="textarea"
              :rows="2"
              maxlength="500"
              :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
              :disabled="isViewDisabled"
              clearable
              size="medium"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col v-if="createDataDisabled">
          <div style="font-size: 14px; color: #717171;">
            <span
              >Create：{{
                formData.createByName ? formData.createByName : "--"
              }}
              at {{ formData.createDate ? formData.createDate : "--" }}</span
            >
          </div>
          <div style="font-size: 14px; color: #717171;">
            <span
              >Modify：{{
                formData.modifyByName ? formData.modifyByName : "--"
              }}
              at {{ formData.modifyDate ? formData.modifyDate : "--" }}</span
            >
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      type: "",
      createDataDisabled: false,
      isViewDisabled: false,
      formData: {
        appraisalGroupName: "", // 评分组名称
        appraisalGroupNameEn: "", // 评分组英文名称
        sortOrder: 0, // 排序
        createByName: "",
        createDate: "",
        modifyByName: "",
        modifyDate: "",
      },
      rules: {
        appraisalGroupName: [
          {
            required: true,
            message: this.$l("form_label_entGroupName") || "请输入评分组名称",
            trigger: "blur",
          },
        ],
        appraisalGroupNameEn: [
          {
            required: true,
            message:
              this.$l("form_label_entGroupNameEn") || "请输入评分组英文名称",
            trigger: "blur",
          },
        ],
      },
    }
  },
  methods: {
    // 初始化表单数据
    init() {
      this.isViewDisabled = false
      this.reset()
      this.$refs.form.resetFields()
    },
    // 加载表单数据（新增，编辑，详情）
    fromLoad(ref, val = "") {
      this.init()
      this.type = ref
      if (ref === "add") {
        this.createDataDisabled = false
        this.formData.ratingItemStatus = "Y"
      } else if (ref === "edit") {
        this.createDataDisabled = true
        this.$api.scmAppraisalGroupDetailApi(val).then((res) => {
          this.formData = res.body
        })
      }
    },
    save() {
      if (this.type === "add") {
        this.add()
      } else if (this.type === "edit") {
        this.update()
      }
    },
    add() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.scmAppraisalGroupAddApi(this.formData).then(() => {
            this.$message({
              showClose: true,
              message: this.$l("INDEX.tips_save_ok") || "保存成功",
              type: "success",
            })
            // 通知父组件保存成功
            this.$emit("success")
          })
        } else {
          return false
        }
      })
    },
    update() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.scmAppraisalGroupUpdateApi(this.formData).then(() => {
            this.$message({
              showClose: true,
              message: this.$l("INDEX.tips_save_ok") || "保存成功",
              type: "success",
            })
            // 通知父组件保存成功
            this.$emit("success")
          })
        } else {
          return false
        }
      })
    },
    reset() {
      this.type = ""
      this.formData = {
        appraisalGroupName: "", // 评分组名称
        appraisalGroupNameEn: "", // 评分组英文名称
        sortOrder: 0, // 排序
        createByName: "",
        createDate: "",
        modifyByName: "",
        modifyDate: "",
      }
    },
  },
}
</script>
